export default __webpack_public_path__ + "static/mobile-app-design-services-7f05e94ac11cc32fa3461a9ea400f436.webp";